import { useMemo, useState } from 'react'
import { getTps, getUsuarioInfo } from '../../../../services/localstorage/localstorage.service'
import { getCompaniesGroupAssociatedToUser } from '../../../../services/api/https/system/system.http'
import { errorHandler } from '../../../../services/util/error.service'
import CargasParadasTpsHttp from '../../../../services/api/https/dashboard/cargas-paradas-tps.http'

const entregaFields = {
  index: '#',
  data_operacao: 'Data Operação',
  identificador: 'Identificador',
  cliente: 'Cliente',
  cidade: 'Cidade',
  bairro: 'Bairro',
  cnpj: 'CNPJ',
  qte_caixas: 'Qte. Caixas',
  qte_dias: 'Dias',
  motivo_atraso: 'Motivo Atraso',
  empresa: 'Empresa',
}

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  FETCH_INITIAL_INFO: 'Adquirindo grupos de empresas',
  GET_INFO: 'Adquirindo informações . . . isso pode demorar mais tempo do que o normal',
}

const INITIAL_DASHBOARD_INFO = {
  cargas_paradas: [],
  total_cargas_paradas: 0,
  total_qte_com_motivo: 0,
  total_qte_sem_motivo: 0,
  total_qte_sem_motivo_percent: 0,
  motivos_graph_data: {
    cargas_paradas: [],
  },
}

const INITIAL_STATE = {
  dashboardInfo: {
    ...INITIAL_DASHBOARD_INFO,
  },
  companyGroupSelected: null,
  modalInfo: {
    fields: [],
    data: [],
    title: '',
    show: false,
    typeModal: 'veiculos',
    width: 600,
    fieldParser: {},
  },
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useCargasParadasTps() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers
    const throwError = message => {
      setState(prevState => ({ ...prevState, errorMessage: message }))
    }

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      generateColorsToGraph() {
        return (
          '#' +
          parseInt(Math.random() * 0xffffff)
            .toString(16)
            .padStart(3, '0')
        )
      },

      getCompaniesGroupAssociatedToUser() {
        getCompaniesGroupAssociatedToUser(getUsuarioInfo().id)
          .then(response =>
            setState(prevState => ({
              ...prevState,
              companiesGroups: response.map(c => ({
                label: c.company_group_name,
                value: c.company_group_id,
              })),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      getCargasParadasTps(selectedCompany, selectedTp) {
        let tpsIds = selectedTp
        if (!tpsIds) tpsIds = getTps(false).map(tp => tp.id)
        CargasParadasTpsHttp.getCargasParadasTps(selectedCompany.value, tpsIds.toString())
          .then(dashboardInfo =>
            setState(prevState => ({
              ...prevState,
              cellColors: dashboardInfo.motivos_graph_data.cargas_paradas.map(e =>
                this.generateColorsToGraph(),
              ),
              dashboardInfo: dashboardInfo,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      //Events
      onClickOpenModal(typeModal, value) {
        switch (typeModal) {
          case 'com_motivo':
            if (value.qte_com_motivo === 0) throwError('Não existem items a serem exibidos')
            else {
              const { cidade, bairro, cnpj, qte_caixas, ...fields } =
                value.modal_infos.com_motivo[0]
              setState(prevState => ({
                ...prevState,
                modalInfo: {
                  data: value.modal_infos.com_motivo,
                  fields: Object.keys({ ...fields }),
                  show: true,
                  title: 'Entregas Com Motivos',
                  width: 900,
                  fieldParser: entregaFields,
                  expander: true,
                  expanderTemplate: 'cargasParadas',
                },
              }))
            }
            break

          case 'sem_motivo':
            if (value.qte_sem_motivo === 0) throwError('Não existem items a serem exibidos')
            else {
              const { cidade, bairro, cnpj, qte_caixas, ...fields } =
                value.modal_infos.sem_motivo[0]
              setState(prevState => ({
                ...prevState,
                modalInfo: {
                  data: value.modal_infos.sem_motivo,
                  fields: Object.keys({ ...fields }),
                  show: true,
                  title: 'Entregas Sem Motivos',
                  width: 800,
                  fieldParser: entregaFields,
                  expander: true,
                  expanderTemplate: 'cargasParadas',
                },
              }))
            }
            break

          default:
            break
        }
      },

      onInit() {
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.FETCH_INITIAL_INFO }))
      },

      onCompanyGroupChange(value) {
        setState(prevState => ({ ...prevState, companyGroupSelected: value }))
      },

      onBtnPesquisar(selectedCompany) {
        if (!selectedCompany)
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione um Grupo de Empresas' }))
        else setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.GET_INFO }))
      },

      onModalClose() {
        setState(prevState => ({ ...prevState, modalInfo: { ...INITIAL_STATE.modalInfo } }))
      },
    }
  }, [])

  return { state, localDispatch }
}
